import { Check } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const points = [
  "Vous répétez les mêmes situations malgré vos efforts",
  "Vous avez des réactions émotionnelles difficiles à maîtriser",
  "Vous vous sentez bloqué sans comprendre pourquoi",
  "Certaines relations sont sources de tension ou de souffrance",
  "Vous avez le sentiment de porter quelque chose de lourd",
  "Vous avez parfois l'impression que votre histoire se rejoue",
];

export default function Recognition() {
  return (
    <section
      id="reconnaissance"
      data-testid="recognition-section"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
            — Reconnaissance
          </span>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 max-w-2xl leading-[1.1]">
            Vous vous reconnaissez si…
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-x-12 gap-y-6">
          {points.map((p, i) => (
            <Reveal key={p} delay={i * 0.05}>
              <div
                data-testid={`recognition-item-${i}`}
                className="group flex items-start gap-4 py-5 border-b border-[#DDD7E2]"
              >
                <span className="mt-1 flex-shrink-0 w-8 h-8 rounded-full bg-[#F3EEF4] flex items-center justify-center group-hover:bg-[#C98FA3] transition-colors">
                  <Check className="w-4 h-4 text-[#C98FA3] group-hover:text-white transition-colors" />
                </span>
                <p className="text-base md:text-lg text-[#1E1E2A] leading-relaxed">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-16 max-w-3xl text-lg md:text-xl text-[#5F6170] leading-relaxed font-serif-display italic">
            Ces schémas ne sont pas toujours conscients. Ils peuvent s'inscrire dans votre vécu,
            votre enfance ou votre histoire familiale.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
